import React from 'react';
import ClassAssembly9A  from 'views/ClassAssembly9A';

const ClassAssembly9APage = () => {
    return <ClassAssembly9A />;
  };
  
  export default ClassAssembly9APage;

  //9A